import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../../ReduxStore/userReducer";
// adjust the import path

const ProtectedRoute = ({ allowedRoles }) => {
  const userData = useSelector(selectUser);
  const accessLevel = userData?.AccessLevel;
  if (!userData) {
    console.log("No user data, redirecting to login");
    return <Navigate to="/" replace />;
  }
  if (allowedRoles && !allowedRoles.includes(accessLevel)) {
    console.log("Access denied, redirecting to dashboard");
    return <Navigate to="/DashBoard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
